var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { VendorPaymentAdapter } from './VendorPaymentAdapter';
import AdyenCheckout from '@adyen/adyen-web';
import { FocusedField, GooglePayButtonColor, SupportedPaymentMethodMappings } from '../services/ApplicationSession';
import { BillingGatewayRegion, Environment } from '../services/Environment';
import { AdyenEnvironmentMapping, AdyenCheckoutErrors, getTraditionalLocale } from '../common/Constants';
import { PaymentError } from '../services/ErrorService';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
var AdyenAdapter = /** @class */ (function (_super) {
    __extends(AdyenAdapter, _super);
    function AdyenAdapter(sessionConfig, billingGatewayService, callbacks) {
        var _this = _super.call(this) || this;
        _this.environmentMapping = AdyenEnvironmentMapping;
        _this.onProcessing = callbacks.onProcessing;
        _this.setErrorDetails = callbacks.setErrorDetails;
        var placeHolderTranslations = {
            'creditCard.expiryDateField.placeholder': '',
            'creditCard.cvcField.placeholder': '',
            'creditCard.cvcField.placeholder.3digits': '',
            'creditCard.cvcField.placeholder.4digits': '',
            'creditCard.numberField.placeholder': ''
        };
        var adyenConfig = {
            environment: _this.getEnvironmentValue(billingGatewayService.config),
            clientKey: sessionConfig.adyenClientKey,
            onAdditionalDetails: function (state, component) {
                if (state.data) {
                    callbacks.onProcessing(true);
                    var paymentMethod_1 = sessionConfig.getSelectedPaymentMethod();
                    if (!paymentMethod_1) {
                        throw new Error('No payment method selected');
                    }
                    if (paymentMethod_1 === SupportedPaymentMethodMappings['webDropInPaypal']) {
                        component.setStatus('ready');
                    }
                    billingGatewayService
                        .submitPaymentDetails(sessionConfig, state.data)
                        .then(function (response) {
                        var _a;
                        (_a = callbacks.onPaymentSuccess) === null || _a === void 0 ? void 0 : _a.call(callbacks, {
                            paymentMethod: paymentMethod_1,
                            ok: true,
                            status: 'success',
                            billingToken: sessionConfig.billingToken,
                            billingInformation: sessionConfig.billingInformation,
                            additionalData: _this.parseAdditionalTransactionInfo(paymentMethod_1, response)
                        });
                    })
                        .catch(function (error) {
                        var _a;
                        (_a = callbacks.onPaymentFailure) === null || _a === void 0 ? void 0 : _a.call(callbacks, PaymentError.parsePaymentFailure({ paymentMethod: paymentMethod_1 }, error));
                        _this.setErrorDetails(error);
                    })
                        .finally(function () {
                        component.setStatus('ready');
                        callbacks.onProcessing(false);
                    });
                }
            },
            locale: sessionConfig.locale,
            translations: {
                'en-US': placeHolderTranslations,
                'ja-JP': placeHolderTranslations,
                'en-GB': placeHolderTranslations,
                'en-AU': placeHolderTranslations,
                'en-SG': placeHolderTranslations,
                'ms-MY': placeHolderTranslations,
                'en-TH': placeHolderTranslations,
                'th-TH': placeHolderTranslations
            }
        };
        _this.checkoutClient = AdyenCheckout(adyenConfig);
        _this.billingGatewayService = billingGatewayService;
        return _this;
    }
    AdyenAdapter.prototype.initializeCreditCard = function (formRef, callbacks, cardFieldStyling, supportedCardBrands, onInitialized) {
        return __awaiter(this, void 0, void 0, function () {
            var checkoutClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutClient];
                    case 1:
                        checkoutClient = _a.sent();
                        checkoutClient
                            .create('securedfields', {
                            brands: supportedCardBrands,
                            onBrand: function (evt) {
                                if (callbacks.onBrand) {
                                    callbacks.onBrand(evt.brand === 'card' ? undefined : evt.brand); //evt.brandImageUrl);
                                }
                            },
                            onFocus: function (evt) {
                                var _a, _b, _c;
                                switch (evt.fieldType) {
                                    case 'encryptedCardNumber':
                                        (_a = callbacks.onFocusChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, FocusedField.CARD_NUMBER, evt.focus, evt.numChars == 0);
                                        break;
                                    case 'encryptedExpiryDate':
                                        (_b = callbacks.onFocusChange) === null || _b === void 0 ? void 0 : _b.call(callbacks, FocusedField.EXPIRY_DATE, evt.focus, evt.numChars == 0);
                                        break;
                                    case 'encryptedSecurityCode':
                                        (_c = callbacks.onFocusChange) === null || _c === void 0 ? void 0 : _c.call(callbacks, FocusedField.SECURITY_CODE, evt.focus, evt.numChars == 0);
                                        break;
                                }
                            },
                            onConfigSuccess: onInitialized,
                            onChange: function (evt) {
                                var _a, _b, _c, _d, _e, _f;
                                var validCardBrand = true;
                                var eventError = evt === null || evt === void 0 ? void 0 : evt.errors;
                                if (eventError && (eventError === null || eventError === void 0 ? void 0 : eventError.encryptedCardNumber) && eventError.encryptedCardNumber.errorMessage === 'Unsupported card entered') {
                                    validCardBrand = false;
                                }
                                var validity = {
                                    validCreditCardNumber: ((_a = evt.valid) === null || _a === void 0 ? void 0 : _a.encryptedCardNumber) || false,
                                    validCardBrand: validCardBrand,
                                    validExpiryMonth: ((_b = evt.valid) === null || _b === void 0 ? void 0 : _b.encryptedExpiryMonth) || false,
                                    validExpiryYear: ((_c = evt.valid) === null || _c === void 0 ? void 0 : _c.encryptedExpiryYear) || false,
                                    validCVV: ((_d = evt.valid) === null || _d === void 0 ? void 0 : _d.encryptedSecurityCode) || false,
                                    isValid: evt.isValid
                                };
                                if (validity.isValid) {
                                    var creditCardFieldsValid = {
                                        riskData: evt.data.riskData,
                                        type: evt.data.paymentMethod.type,
                                        brand: evt.data.paymentMethod.brand,
                                        encryptedCardNumber: evt.data.paymentMethod.encryptedCardNumber,
                                        encryptedExpiryMonth: evt.data.paymentMethod.encryptedExpiryMonth,
                                        encryptedExpiryYear: evt.data.paymentMethod.encryptedExpiryYear,
                                        encryptedSecurityCode: evt.data.paymentMethod.encryptedSecurityCode,
                                        browserInfo: evt.data.browserInfo
                                    };
                                    (_e = callbacks.onCreditCardFormValidated) === null || _e === void 0 ? void 0 : _e.call(callbacks, creditCardFieldsValid);
                                }
                                (_f = callbacks.onValidityChange) === null || _f === void 0 ? void 0 : _f.call(callbacks, validity);
                            },
                            styles: cardFieldStyling
                        })
                            .mount(formRef.current);
                        return [2 /*return*/];
                }
            });
        });
    };
    AdyenAdapter.prototype.remountCreditCardForm = function (locale) {
        return __awaiter(this, void 0, void 0, function () {
            var checkoutClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutClient];
                    case 1:
                        checkoutClient = _a.sent();
                        return [4 /*yield*/, checkoutClient.update({ locale: locale })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdyenAdapter.prototype.initializeGooglePay = function (formRef, googlePayConfiguration, buttonColor, callback, onProcessing, onAuthorized, isGooglePayAvailable) {
        return __awaiter(this, void 0, void 0, function () {
            var checkoutClient, googlePayComponent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutClient];
                    case 1:
                        checkoutClient = _a.sent();
                        googlePayComponent = checkoutClient.create('googlepay', {
                            buttonSizeMode: 'fill',
                            buttonType: 'plain',
                            buttonLocale: 'en',
                            emailRequired: true,
                            buttonColor: buttonColor || GooglePayButtonColor.BLACK,
                            onChange: callback,
                            onError: function (error) {
                                // error is of type 'any', and it can be observed that there are differences when using JSON.stringify(error).
                                // to see the differences, uncomment the console logs below.
                                // console.log('error', error);
                                // console.log('error.toString()', error.toString());
                                // console.log('JSON.stringify(error)', JSON.stringify(error));
                                // console.log('error.name', error.name);
                                // console.log('error.message', error.message);
                                // console.log('error.cause', error.cause);
                                // console.log('error.stack', error.stack);
                                //
                                // as per Adyen docs we should just use the 'name', 'message' and 'stack' fields from 'error'
                                // https://docs.adyen.com/online-payments/build-your-integration/sessions-flow/?platform=Web&integration=Components&version=5.63.0
                                // This is an Adyen-specific error callback.
                                // An errror is dispatched and this is triggered across payment methods.
                                // We should hide the spinner regardless of the error.
                                if ((error === null || error === void 0 ? void 0 : error.name) === AdyenCheckoutErrors.CANCEL) {
                                    console.warn(error);
                                    _this.onProcessing(false);
                                }
                                // TODO: what other errors should we call onProcessing(false)?
                            },
                            billingAddressRequired: true,
                            billingAddressParameters: {
                                format: 'FULL' // so the complete address is returned
                            },
                            onClick: function (resolve) {
                                onProcessing(true);
                                resolve();
                            },
                            onAuthorized: onAuthorized,
                            configuration: googlePayConfiguration.configuration
                        });
                        googlePayComponent.isAvailable().then(function () {
                            isGooglePayAvailable(true);
                            googlePayComponent.mount(formRef.current);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AdyenAdapter.prototype.initializePayPal = function (formRef, paypalConfiguration, callback, onShopperDetails, isPayPalAvailable, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var checkoutClient;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutClient];
                    case 1:
                        checkoutClient = _a.sent();
                        checkoutClient
                            .create('paypal', {
                            configuration: paypalConfiguration.configuration,
                            // onShippingChange: (data: any, action: any) => {
                            //     console.log('Shipping Change Data: ', data);
                            //     action.enable();
                            // },
                            onInit: function (data, actions) {
                                actions.enable();
                                isPayPalAvailable(true);
                            },
                            onSubmit: function (data, component) {
                                callback(data, component);
                            },
                            onShopperDetails: onShopperDetails,
                            onError: function (error) {
                                if ((error === null || error === void 0 ? void 0 : error.name) === AdyenCheckoutErrors.CANCEL) {
                                    console.warn(error);
                                }
                                else {
                                    console.error(error);
                                }
                                // hide spinner regardless of error
                                _this.onProcessing(false);
                            },
                            // onClick: callback,
                            blockPayPalCreditButton: true,
                            blockPayPalPayLaterButton: true,
                            blockPayPalVenmoButton: true,
                            vault: true,
                            style: {
                                disableMaxWidth: true,
                                height: 48 // as defined in figma
                            },
                            locale: getTraditionalLocale(locale) // works on the Paypal loading background screen
                        })
                            .mount(formRef.current);
                        return [2 /*return*/];
                }
            });
        });
    };
    AdyenAdapter.prototype.submitPaymentForm = function (config, paymentInformation, threedsActionContainer, setErrorDetails, actionCallback, onPaymentSuccess, onPaymentFailure) {
        return __awaiter(this, void 0, void 0, function () {
            var baseResponse, tokenizationResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseResponse = {
                            paymentMethod: SupportedPaymentMethodMappings[paymentInformation.paymentType]
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        setErrorDetails(undefined);
                        return [4 /*yield*/, this.billingGatewayService.submitTokenizationIntent(config, paymentInformation)];
                    case 2:
                        tokenizationResult = _a.sent();
                        // This will trigger straight forward payment methods (e.g. CC, GPay)
                        if (!(tokenizationResult === null || tokenizationResult === void 0 ? void 0 : tokenizationResult.action)) {
                            onPaymentSuccess === null || onPaymentSuccess === void 0 ? void 0 : onPaymentSuccess(__assign(__assign({}, baseResponse), { ok: true, status: 'success', billingToken: config.billingToken, billingInformation: config.billingInformation, additionalData: this.parseAdditionalTransactionInfo(baseResponse.paymentMethod, tokenizationResult) }));
                            this.onProcessing(false);
                            return [2 /*return*/];
                        }
                        // This will trigger additional steps for certain payment methods (e.g. Paypal)
                        if (actionCallback) {
                            actionCallback(tokenizationResult.action);
                            return [2 /*return*/];
                        }
                        if (!threedsActionContainer) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.checkoutClient];
                    case 3:
                        (_a.sent()).createFromAction(tokenizationResult.action).mount(threedsActionContainer.current);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        setErrorDetails(error_1);
                        onPaymentFailure === null || onPaymentFailure === void 0 ? void 0 : onPaymentFailure(PaymentError.parsePaymentFailure(baseResponse, error_1));
                        this.onProcessing(false);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // This should be remove shortly, the correct implementation should be done in the BG Core.
    AdyenAdapter.prototype.parseAdditionalTransactionInfo = function (paymentMethod, tokenizationResponse) {
        var _a, _b, _c, _d, _e;
        switch (paymentMethod) {
            case SupportedPaymentMethodMappings.webDropInCreditCard:
            case SupportedPaymentMethodMappings.webDropInGooglePay: {
                var cardBrand = (_a = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.paymentMethod) === null || _a === void 0 ? void 0 : _a.brand;
                var cardLastFourDigits = (_b = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _b === void 0 ? void 0 : _b.cardSummary;
                var cardBin = (_c = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _c === void 0 ? void 0 : _c.cardBin;
                var cardExpirationDate = (_d = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _d === void 0 ? void 0 : _d.expiryDate;
                if (cardExpirationDate) {
                    var parsedDate = dayjs(cardExpirationDate, ['M/YYYY', 'MM/YYYY'], true);
                    cardExpirationDate = undefined;
                    if (parsedDate.isValid()) {
                        cardExpirationDate = parsedDate.format('MM/YYYY').toString();
                    }
                }
                return { cardBin: cardBin, cardBrand: cardBrand, cardExpirationDate: cardExpirationDate, cardLastFourDigits: cardLastFourDigits };
            }
            case SupportedPaymentMethodMappings.webDropInPaypal: {
                var paypalEmail = (_e = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _e === void 0 ? void 0 : _e.paypalEmail;
                return { paypalEmail: paypalEmail };
            }
            default:
                return {};
        }
    };
    // This should be removed as well, the correct implementation should be done in the BG API.
    AdyenAdapter.prototype.getEnvironmentValue = function (sessionConfig) {
        if (sessionConfig.environment !== Environment.PROD) {
            return 'test';
        }
        var environmentValue = this.environmentMapping[(sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.region) || BillingGatewayRegion.US];
        return environmentValue;
    };
    return AdyenAdapter;
}(VendorPaymentAdapter));
export { AdyenAdapter };
